/**
 * Calculate the bracket for a given bracket size and a number - or list of actual numbers which will be summed together
 */
export function calcBracket(
  bracketSize: number,
  ...actual: Array<number | null | undefined>
) {
  const actualNumber = actual.map((n) => n ?? 0).reduce((acc, n) => acc + n, 0);
  return Math.floor(actualNumber / bracketSize);
}
